import type { EChartsInstance } from 'echarts-for-react/lib/types';

/** Show the full data range without changing other chart settings. */
export const resetChartZoom = (
  chartInstance: Pick<EChartsInstance, 'dispatchAction'> | null | undefined,
): void => {
  chartInstance?.dispatchAction({ type: 'dataZoom', start: 0, end: 100 });
};
